import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { reformatNumber } from 'shared/helpers/formatNumber';

import { actions, selectUserInfoById } from '../redux';
import { actions as authActions } from '../../Auth';

export function useWithdrawalModel() {
  const dispatch = useDispatch();
  const history = useHistory();

  const { actionProcessing } = useSelector(state => state.users);
  const { currency } = useSelector(state => state.auth);
  // Пользователь, с которого осуществляется вывод
  const { userId: userIdFrom } = useParams();
  const userInfoFrom = useSelector(selectUserInfoById(userIdFrom));
  // Агент, которому начисляются средства
  const userIdTo = useMemo(() => userInfoFrom?.parentAgentId, [userInfoFrom]);
  const userInfoTo = useSelector(selectUserInfoById(userIdTo));

  const [amount, setAmount] = useState('');
  const correctAmount = useMemo(() => reformatNumber(amount), [amount]);

  useEffect(() => {
    dispatch(actions.getUserInfo({ id: userIdFrom }));
  }, [dispatch, userIdFrom]);

  useEffect(() => {
    if (userIdTo !== undefined) dispatch(actions.getUserInfo({ id: userIdTo }));
  }, [dispatch, userIdTo]);

  const changeValue = useCallback(e => {
    setAmount(e.currentTarget.value);
  }, []);

  const handleInsertAmount = useCallback(
    plusSum => {
      const rightValue = correctAmount + plusSum;
      setAmount(rightValue);
    },
    [correctAmount],
  );

  const onSubmit = useCallback(() => {
    dispatch(
      actions.depositOrWithdrawal({
        amount: correctAmount,
        operation: 1,
        id: userIdFrom,
        callback: () => {
          dispatch(actions.getUserInfo({ id: userIdFrom }));
          dispatch(authActions.getBalance());
          history.push('/users/all');
        },
      }),
    );
  }, [history, dispatch, correctAmount, userIdFrom]);

  const players = useMemo(
    () => [
      {
        username: userInfoFrom?.username,
        balance: userInfoFrom?.balance,
        role: userInfoFrom?.role,
        title: 'from',
      },
      { username: userInfoTo?.username, balance: userInfoTo?.balance, role: userInfoTo?.role, title: 'to' },
    ],
    [userInfoFrom, userInfoTo],
  );

  return {
    players,
    actionProcessing,
    currency,
    amount,
    correctAmount,
    isLoaded: Boolean(userInfoFrom) && Boolean(userInfoTo),
    onSubmit,
    changeValue,
    handleInsertAmount,
  };
}
